async function getCustomerPoints(shopifyCustomerId, apiBaseUrl = 'https://xcldpqvrbwoiygcfrvtq.supabase.co/functions/v1/card-collection') {
    if (!shopifyCustomerId) {
        console.error('Shopify Customer ID is required');
        return;
    }

    // Use server-side API endpoint to keep API keys secure
    const baseUrl = apiBaseUrl.replace(/\/$/, '');
    const apiUrl = `${baseUrl}/joy-points?customerId=${encodeURIComponent(shopifyCustomerId)}`;

    try {
        const response = await fetch(apiUrl);

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && result.data) {
            const points = result.data.point;
            console.log('Customer points:', points);

            const pointElement = document.getElementById('customer-points');
            if (pointElement) {
                pointElement.innerText = points.toLocaleString('id-ID');
            }
        } else {
            console.error('Failed to fetch customer points:', result);
            const pointElement = document.getElementById('customer-points');
            if (pointElement) pointElement.innerText = 'Error';
        }
    } catch (error) {
        console.error('Error fetching customer points:', error);
        const pointElement = document.getElementById('customer-points');
        if (pointElement) pointElement.innerText = 'Error';
    }
}